module.exports = __webpack_public_path__ + "img/member-avatar.52f6fa60.png";